import React, { Component } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import {connect} from "react-redux"
import dashboard from './redux/actions/dashboard'
import auth from './redux/actions/auth'

import PrivateRoute from './components/PrivateRoute'

// Main
import Login from './pages/Main/Login'
import Home from './pages/Main/Home'
import Dashboard from './pages/Main/Dashboard'
import Trial from './pages/Main/Trial'
import tes from './pages/Main/tes'

// Dokumen
import Dokumen from './pages/dokumen/Dokumen'
import DownloadDocument from './pages/dokumen/DownloadDocument'
import Report from './pages/dokumen/Report'
import ReportDokumen from './pages/dokumen/ReportDokumen'

// Master Data
import MasterEmail from './pages/Master/MasterEmail'
import MasterPic from './pages/Master/MasterPic'
import MasterDokumen from './pages/Master/MasterDokumen'
import MasterAlasan from './pages/Master/MasterAlasan'
import MasterUser from './pages/Master/MasterUser'
import MasterDepo from './pages/Master/MasterDepo'
import MasterDivisi from './pages/Master/MasterDivisi'

// Setting Page
import SettingDokumen from './pages/Setting/SettingDokumen'
import LockDepo from './pages/Setting/LockDepo'
import DateClossing from './pages/Setting/DateClossing'

// Upload Sales Tax
import UploadSales from './pages/Sales/UploadSales'
import LogUpload from './pages/Sales/LogUpload'

// Inventory
import MasterMovement from './pages/Inventory/MasterMovement'
import MasterAreaInventory from './pages/Inventory/MasterAreaInventory'
import ReportInventory from './pages/Inventory/ReportInventory'
import ReportMb51 from './pages/Inventory/ReportMb51'

// End Stock
import ReportEndstock from './pages/endstock/ReportEndstock'

// Sales Console
import SalesConsole from './pages/salesConsole/ReportSalesConsole'

//PNL
import ReportPnl from './pages/pnl/ReportPnl'

//Jurnal kasbank
import ReportJurnalKasbank from './pages/jurnalKasbank/ReportJurnalKasbank'

//Jurnal kasbank
import ReportSalesTax from './pages/salesTax/ReportSalesTax'

// denie page
import AccessDenied from './components/AccessDenied'

class App extends Component {

    componentDidMount(){
        if (localStorage.getItem('token')) {
            this.props.setToken(localStorage.getItem('token'))  
        }
    }

    render() {
        return (
        <BrowserRouter>
            <Switch>
                <Route path='/login' exact component={Login} />
                <Route path='/tes' exact component={tes} />
                <PrivateRoute path='/' exact>
                    <Home />
                </PrivateRoute>
                <PrivateRoute path='/dashboard'>
                    <Dashboard />
                </PrivateRoute>
                <PrivateRoute path='/access-denied' exact>
                    <AccessDenied />
                </PrivateRoute>

                
                <PrivateRoute path='/dokumen'>
                    <Dokumen />
                </PrivateRoute>
                <PrivateRoute path='/download'>
                    <DownloadDocument />
                </PrivateRoute>
                <PrivateRoute path="/email">
                    <MasterEmail />
                </PrivateRoute>
                <PrivateRoute path="/pic">
                    <MasterPic />
                </PrivateRoute>
                <PrivateRoute path="/master/dokumen">
                    <MasterDokumen />
                </PrivateRoute>
                <PrivateRoute path="/alasan">
                    <MasterAlasan />
                </PrivateRoute>
                <PrivateRoute path="/user">
                    <MasterUser />
                </PrivateRoute>
                <PrivateRoute path="/depo">
                    <MasterDepo />
                </PrivateRoute>
                <PrivateRoute path="/divisi">
                    <MasterDivisi />
                </PrivateRoute>
                <PrivateRoute path="/report">
                    <Report />
                </PrivateRoute>
                <PrivateRoute path="/report-dokumen">
                    <ReportDokumen />
                </PrivateRoute>
                <PrivateRoute path="/setting/dokumen">
                    <SettingDokumen />
                </PrivateRoute>
                <PrivateRoute path="/lock">
                    <LockDepo />
                </PrivateRoute>
                <PrivateRoute path="/date">
                    <DateClossing />
                </PrivateRoute>
                <PrivateRoute path="/coba">
                    <Trial />
                </PrivateRoute>
                <PrivateRoute path="/uploadsales">
                    <UploadSales />
                </PrivateRoute>
                <PrivateRoute path="/logupload">
                    <LogUpload />
                </PrivateRoute>

                {/* Inventory */}
                <PrivateRoute path="/movement">
                    <MasterMovement />
                </PrivateRoute>
                <PrivateRoute path="/inventory">
                    <MasterAreaInventory />
                </PrivateRoute>
                <PrivateRoute path="/report-inventory">
                    <ReportInventory />
                </PrivateRoute>
                <PrivateRoute path="/report-mb51">
                    <ReportMb51 />
                </PrivateRoute>
                
                <PrivateRoute path="/report-endstock">
                    <ReportEndstock />
                </PrivateRoute>

                <PrivateRoute path="/sales-console">
                    <SalesConsole />
                </PrivateRoute>

                <PrivateRoute path="/report-pnl">
                    <ReportPnl />
                </PrivateRoute>

                <PrivateRoute path="/report-jurnal-kasbank">
                    <ReportJurnalKasbank />
                </PrivateRoute>

                <PrivateRoute path="/report-sales-tax">
                    <ReportSalesTax />
                </PrivateRoute>
            </Switch>
        </BrowserRouter>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    dashboard: state.dashboard
  })
  
  const mapDispatchToProps = {
    setToken: auth.setToken,
    getDashboard: dashboard.getDashboard,
    getDashboardPic: dashboard.getDashboardPic
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(App)
